<template>
    <div>
        <el-input-number
            v-if="mode === 'edit'"
            :min="min"
            :placeholder="placeholder"
            :modelValue="modelValue"
            :controls="controls"
            @change="update"
        >
        </el-input-number>
        <p v-else>
            {{ modelValue }}
        </p>
    </div>
</template>

<script>
export default {
    props: {
        mode: {
            type: String,
        },
        min: {
            type: Number,
            required: false,
            default: 0,
        },
        controls: {
            type: Boolean,
            required: false,
            default: false,
        },
        modelValue: {
            type: Number,
            required: false,
            default: 0,
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {};
    },
    methods: {
        update(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
};
</script>
